import { useEffect, useState } from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const arr = (x) => (Array.isArray(x) ? x : []);

export function SeoArticle({ k }) {
  const [c, setC] = useState(null);
  useEffect(() => {
    let alive = true;
    fetch(`${process.env.PUBLIC_URL || ""}/content/extra-${k}.json`)
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (alive) setC(j?.content || null); })
      .catch(() => {});
    return () => { alive = false; };
  }, [k]);
  if (!c || !arr(c.sections).length) return null;
  return (
    <section className="border-b border-line bg-white py-10 md:py-14" aria-labelledby={`seo-${k}`} data-testid={`seo-article-${k}`}>
      <div className="container-x max-w-4xl">
        <h2 id={`seo-${k}`} className="text-3xl font-semibold leading-tight sm:text-4xl">{c.heading}</h2>
        <div className="mt-6">
          {arr(c.sections).map((s, i) => (
            <div key={i} className="mb-7">
              <h3 className="text-2xl font-semibold">{s.heading}</h3>
              {arr(s.paragraphs).map((p, j) => <p key={j} className="mt-3 text-[16px] leading-[1.8] text-body">{p}</p>)}
            </div>
          ))}
          </div>
          {arr(c.faqs).length > 0 && (
            <Accordion type="single" collapsible className="mt-4 rounded-2xl border border-line px-5">
              {arr(c.faqs).map((f, i) => (
                <AccordionItem key={i} value={`s${i}`} className="border-line last:border-0">
                  <AccordionTrigger className="text-left font-sans text-[16px] font-semibold hover:no-underline" data-testid={`seo-faq-${k}-${i}`}>{f.q}</AccordionTrigger>
                  <AccordionContent className="text-[15px] leading-relaxed text-body">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </div>
    </section>
  );
}
